import React, { useState, useRef,useEffect } from 'react'
import { Row, Col, Card } from '@deere/ux.uxframe-react'
import { useLocation } from "react-router-dom";
import ActionsEMReviewSurvey from '../../components/extended-mineral/ActionsEMReviewSurvey';
import CmReviewSection from '../../components/CmReviewSection';
import CustomAlert from '../../components/CustomAlert';
import CampaignClosedAlert from '../../components/CampaignClosedAlert';
import SuppliersEMRTCard from '../../components/extended-mineral/SuppliersEMRTCard';
import {Table as UxTable} from '@deere/ux.uxframe-react'
import CmAgreementPopUp from '../../components/modals/CmAgreementPopUp'
import EMTitle from '../../components/extended-mineral/EMSurveyTitle';
import { deleteEmResponseByResponseId, submitEMResponse } from '../../services/em.service';
import { useOktaAuth } from '@okta/okta-react'
import { useUserInfo } from '../../providers/userProvider'
import { getCampaigsByRn } from '../../services/campaign.service';
import { getEmResponseByResponseIdAndCurrentAssignmentId } from '../../services/em.service';
import { SCBM_USER_TYPE,EM_RESPONSE_STATUS,CRS_REQUEST_STATUS_OBJ, EM_ADMIN_SEC, EM_ADMIN_QUESTION, EM_IF_ADMIN, EM_ADMIN} from '../../utils/surveyLiterals';
import { ModalSubmit } from '../../components/ModalSubmit';
import { ModalGeneric } from '../../components/ModalGeneric';
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { CMDeereUserSubmitConfirmation } from '../../components/modals/CMDeereUserSubmitConfirmation';

export default function ReviewPage() {
    const { t } = useTranslation();
    const history = useHistory();
    const userInfo = useUserInfo();
    const { authState } = useOktaAuth();
    const location = useLocation();
    const [statusSaved, setStatusSaved] = useState(undefined);
    const [survey] = useState(location.state.survey);
    const [assignmentId] = useState(location.state.assignmentId);    
    const [responseId] = useState(location.state.responseId);    
    const [campaignAssigned, setCampaignAssigned] = useState();
    const [assignmentsInResponse, setAssignmentsInResponse] = useState([]);
    const [containsError, setContainsError] = useState();
    const [emResponse,setEmResponse] = useState();
    const sections = survey.sections.filter(q => q.active).sort((a, b) => (a.id > b.id) ? 1 : -1)
    
    let sectionsTitles = [...sections.map((section, index) => section.description)]
    const sectionsRef = useRef([new Array(sectionsTitles.length)]);
    const [showAgreement, setShowAgreement] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showValidationModal, setShowValidationModal] = useState(false);
    const [validationMsg, setValidationMsg] = useState("");
    const [showGoToSearchModal, setShowGoToSearchModal]= useState(false);
    const [showDeereUserConfirmation, setShowDeereUserConfirmation] = useState(false);
    const [adminResponsePopup, setAdminResponsePopup] = useState("");
        
    function isValidRN(rn) {
        return rn && !isNaN(rn) && Number.isInteger(parseFloat(rn));//Size in DB
    }

    function validationRules(respCampaign, userInfo) {
        let error;
        if (respCampaign) {
            let campaign = respCampaign;
            if (userInfo.userType !== SCBM_USER_TYPE.SALARY) {
                //it is normal user, we have to validate that the current user has the supplier
                if (!userInfo.suppliers || userInfo.suppliers.length <= 0 || !userInfo.suppliers.includes(campaign.assignments[0].supplierNumber)) {
                    error = 'No suppliers assigned';
                }//else everything is OK
            }//else Read only for the deere employee
        } else {//The assignment does not exist
            error = 'No campaing found';
        }
        return error;
    }

    const handleDeleteResponse = () => {
        try {
            deleteEmResponseByResponseId(emResponse.response.id,authState.accessToken.accessToken).then((response) => {
                if(response && response.numberResponsesDeleted && response.numberResponsesDeleted >0){
                    setShowValidationModal(false);
                    history.goBack();
                }else{
                    setStatusSubmit({ status: true, message: 'Error deleting the response, please refresh the page and try again.', label: 'Danger:', variant: 'danger' });
                    window.scrollTo(0, 0);        
                }
            })
        } catch (error) {
            console.log(error);
            setStatusSubmit({ status: true, message: error, label: 'Danger:', variant: 'danger' });
            window.scrollTo(0, 0);
        }
        return true;
    };

    useEffect(() => {
        //Getting the campaign related with the assignment
        if (userInfo && assignmentId && isValidRN(assignmentId)) {
            getCampaigsByRn(assignmentId, authState.accessToken.accessToken)
            .then((res) => {
                let errorValidation = validationRules(res, userInfo);
                if (errorValidation) { 
                    setContainsError(errorValidation)
                } else {
                    setCampaignAssigned(res);
                }
            }).catch(error => {
                //Campaign not found
                setContainsError('Campaign was not found,please refresh the page if the error persist contact the support department.')
            })            
        }
        if(responseId && assignmentId){
            getEmResponseByResponseIdAndCurrentAssignmentId(responseId,assignmentId, authState.accessToken.accessToken)
            .then((res) => {
                setEmResponse(res);
                const resAssignments = res.assignments ? res.assignments : null;
                let supplierList = resAssignments.map(function(tmpAssignment){
                    return tmpAssignment.supplierNumber;
                })
                setAssignmentsInResponse(resAssignments);
                setValidationMsg("Are you sure you want to delete this response? \n Response No. " + res.response.id + " \n Supplier(s):" + supplierList.toString() );                
            }).catch(error => {
                console.log(error)
                setContainsError('Response was not found, please refresh the page if the error persist contact the support department.')
            })
        }      
    }, [assignmentId,responseId,userInfo,authState.accessToken.accessToken]);

    const setStatusSubmit = (message) => {
        let statusResponse = { ...message };
        setStatusSaved(statusResponse);
    }


    function handlePrint() {
        window.print();
    }

    const handleClose = () => setShowAgreement(false);

    const submitResponseFn = () => {
        try {
            let tmpResponse = {id: emResponse.response.id,status:EM_RESPONSE_STATUS.SUBMITTED,updatedBy: userInfo.userID}
            if(userInfo.roles.includes(EM_IF_ADMIN) || userInfo.roles.includes(EM_ADMIN)){
                let sec = sections.find(sec => sec.code === EM_ADMIN_SEC);
                let que = sec ? sec.questions.find(que => que.code === EM_ADMIN_QUESTION) : null;
                let queId = que && que.id ? que.id : null;
                tmpResponse = {
                    ...tmpResponse, 
                    adminComments: {
                        surveyQuestionId: queId, 
                        answer: adminResponsePopup && adminResponsePopup !== null ? adminResponsePopup : ""
                    }
                }
            }
            submitEMResponse(tmpResponse, authState.accessToken.accessToken).then((camp) => {
                setStatusSubmit({ status: true, message: "Response submitted succesfully", label: 'Success:', variant: 'success' });
                setShowModal(false);
                if( camp &&  camp.campaignAssignmentUpdate && camp.campaignAssignmentUpdate.length>0 && camp.campaignAssignmentUpdate[0].status===CRS_REQUEST_STATUS_OBJ.COMPLETE) {                     
                     setShowGoToSearchModal(true)
                   }
                else{ 
                         history.goBack(); 
                   }

            })
        } catch (error) {
            console.log(error);
            setStatusSubmit({ status: true, message: error, label: 'Danger:', variant: 'danger' });
            setShowModal(false);
            window.scrollTo(0, 0);
        }
    }

    const kindReview = ( code ) => {
        return <>            
            {sections.map((section, index) => {
              if (section.code !== EM_ADMIN_SEC) {
                return (
                  <div key={index}>
                    <div ref={(el) => (sectionsRef.current[index] = el)}>{emResponse && <CmReviewSection section={section} survey={survey} review={true} answers={emResponse.response.emAnswers} />}</div>
                    <br />
                  </div>
                );
              }
            })}
        </>
    }

    const ListParts = (parts) =>{
        return (<>         
            <div>
                <Card>
                    <Card.Body id='Parts'>
                        <Card.Title className='pb-3 font-weight-bold'>
                            Parts
                        </Card.Title>                                
                        <UxTable striped hover size="sm" >
                        <thead>
                            <tr>
                                <th scope="col" className="p-1 text-center">Manufacturer's Part Number</th>
                                <th scope="col" className="p-1 text-center">Manufacturer's Part Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                parts.map((p,index) =>
                                    <tr key={index}>
                                        <td className='p-1'>{p.deerePartNumber}</td>
                                        <td className='p-1'>{p.deerePartDesc}</td>
                                    </tr>)
                            }
                        </tbody>
                        </UxTable>
                    </Card.Body>
                </Card>                                               
            </div> 
            <br/>            
        </>)
    }

    const ListSmelters = (smelters) =>{
        return (<>            
            <div>
                <Card>
                    <Card.Body id='Smelters'>
                        <Card.Title className='pb-3 font-weight-bold'>
                            Smelters
                        </Card.Title>                                
                        <UxTable striped hover size="sm" >
                        <thead>
                            <tr>
                                <th scope="col" className="p-1 text-center">Metal</th>
                                <th scope="col" className="p-1 text-center">Country</th>
                                <th scope="col" className="p-1 text-center">Smelter ID</th>
                                <th scope="col" className="p-1 text-center">Smelter Look-up</th>
                                <th scope="col" className="p-1 text-center">Standard Smelter Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                smelters.map((s,index) =>
                                    <tr key={index}>
                                        <td className='p-1'>{s.metal}</td>
                                        <td className='p-1'>{s.smelterCountry}</td>
                                        <td className='p-1'>{s.smelterIdentification}</td>
                                        <td className='p-1'>{s.smelterLookUp}</td>
                                        <td className='p-1'>{s.smelterName}</td>
                                    </tr>)
                            }
                        </tbody>
                        </UxTable>
                    </Card.Body>
                </Card>                        
            </div>            
            <br />
        </>)
    }

    const ListMineData = (mineData) => {
        return (
          <Card>
            <Card.Body id="Mine">
                <Card.Title className='pb-3 font-weight-bold'>
                    Mine Data
                </Card.Title>
                <UxTable striped hover size="sm" >
                    <thead>
                        <tr>
                            <th scope="col" className="p-1 text-center">Metal</th>
                            <th scope="col" className="p-1 text-center">Smelter Name</th>
                            <th scope="col" className="p-1 text-center">Mine name</th>
                            <th scope="col" className="p-1 text-center">Mine Identification</th>
                            <th scope="col" className="p-1 text-center">Mine Source</th>
                            <th scope="col" className="p-1 text-center">Mine Country</th>
                        </tr>
                    </thead>
                    <tbody>
                        {mineData.map((m) => 
                            <tr key={m.id}>
                                <td className='p-1'>{m.metal}</td>
                                <td className='p-1'>{m.smelterName}</td>
                                <td className='p-1'>{m.mineName}</td>
                                <td className='p-1'>{m.mineIdentification}</td>
                                <td className='p-1'>{m.mineSource}</td>
                                <td className='p-1'>{m.mineCountry}</td>
                            </tr>
                        )}
                    </tbody>
                </UxTable>
            </Card.Body>
          </Card>
        );
      };

    const adminComments = () => {
        let adminSection = sections.find((sec) => sec.code === EM_ADMIN_SEC);
        let adminQue = adminSection ? adminSection.questions.find(que => que.code === EM_ADMIN_QUESTION) : null;
        let adminAns = adminQue ? emResponse.response.emAnswers.find(ans => parseInt(ans.surveyQuestionId) === parseInt(adminQue.id)) : null;
        if (adminAns)
          return (
            <div>
              <div>{emResponse && <CmReviewSection section={adminSection} survey={survey} review={true} answers={emResponse.response.emAnswers} />}</div>
              <br />
            </div>
          );
      };

    const ShowSuppliers = (assignmentsInResponse) => {
        return assignmentsInResponse && assignmentsInResponse.length > 0 ? (<>
                <div>
                    <SuppliersEMRTCard loading={false} assignmentId={0} suppliersInGroup={assignmentsInResponse} canDelete={false} campaign={campaignAssigned}/>
                </div>
                <br />
            </>) : <></>
    }

    const handleShowGoToSearchModal= ()=>{
        history.push({
            pathname: '/',
            state: { previous: history.location.pathname }
        })
    }


    if (!emResponse){
        return (<Row>
            <Col md="24" className="card-body p-3 text-left">
                Loading ...
            </Col>
        </Row>)
    }else{
        return (<div>
            <Row>
                {emResponse && <EMTitle showReviewSuggestion={true} survey={survey} assignment={emResponse.currentAssignment} latestResponse={emResponse.response} handlePrint={handlePrint}/>}                
            </Row>
            <Row>
                {
                statusSaved && statusSaved.status ?
                    <Col><CustomAlert accessibilityLabel={statusSaved.label} variant={statusSaved.variant} title={statusSaved.message} /></Col>
                    : null
                }
                {
                containsError &&
                    <Col><CustomAlert accessibilityLabel={'Danger :'} variant={'danger'} title={containsError}/></Col>                
                }
                <Col><CampaignClosedAlert campaign={campaignAssigned} /></Col>
            </Row>
            <Row>
                <Col xs={24} md={24}>
                    { assignmentsInResponse && ShowSuppliers(assignmentsInResponse)}                                
                    {kindReview(survey.code)}
                    {emResponse && ListParts(emResponse.parts)}
                    {emResponse && ListSmelters(emResponse.response.smelters)}
                    {emResponse && ListMineData(emResponse.response.mineList)}
                    {adminComments()}
                </Col>
            </Row>                        
            {campaignAssigned && <ActionsEMReviewSurvey setShowAgreement={setShowAgreement} emResponse={emResponse.response} setShowValidation={setShowValidationModal} campaign={campaignAssigned} setShowDeereUserConfirmation={setShowDeereUserConfirmation}/>}
            <CmAgreementPopUp showAgreement={showAgreement} handleClose={handleClose} submitResponse={submitResponseFn} survey={survey} />
            <ModalSubmit showModal={showModal} setShowModal = {setShowModal} titleKey={'survey_submit_modal_title'} messageKey={'submit_popup_message'}/>

            <ModalGeneric showModal={showValidationModal}
                          setShowModal ={setShowValidationModal} 
                          labelBtnPrimary={t('t2_remove')}
                          labelBtnSecondary={t('btn_cancel')}
                          handleSubmit={handleDeleteResponse}
                          msgModal={validationMsg}
                          titleModal={t('t2_remove')}
            />

 
           <ModalSubmit showModal={showGoToSearchModal}
                        setShowModal={setShowGoToSearchModal} 
                        titleKey={'cm_lbl_request_completed_title'}
                        messageKey={'cm_lbl_request_completed_message'}
                        buttonKey={'btn_OK'}
           />

           <CMDeereUserSubmitConfirmation
                        showModal={showDeereUserConfirmation}
                        setShowModal={setShowDeereUserConfirmation}
                        labelBtnPrimary={t('btn_review_submit')}
                        titleModal={"Confirmation"}
                        labelBtnSecondary={t('btn_cancel')}
                        handleSubmit={submitResponseFn}
                        adminResponsePopup={adminResponsePopup}
                        setAdminResponsePopup={setAdminResponsePopup}
           />

       
        </div>)
    }
}